import { PageSize } from "@/types/PaginationConstants";

export function removeNonDigitsFromString(value: string): string {
	if (!value) {
		return "";
	}

	const digitFind = value.match(/\d+/g);
	if (!digitFind) {
		return "";
	}

	if (parseInt(digitFind.join("")) < PageSize.Min) {
		return PageSize.Min.toString();
	}

	if (parseInt(digitFind.join("")) > PageSize.Max) {
		return PageSize.Max.toString();
	}

	return digitFind.join("");
}
